<div mat-dialog-title data-testid="title">{{ title }}</div>
<div class="d-flex">
  <mat-form-field>
    <mat-label translate="task/message-template/select-template/search"></mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input autocomplete="off" type="text" [formControl]="searchCtrl" matInput />
    <mat-icon role="button" *ngIf="searchCtrl?.value" (click)="clearSearch()" matSuffix>close</mat-icon>
  </mat-form-field>
  <!-- Language menu -->
  <button
    *ngIf="languagesSet.size"
    data-testid="language-menu-btn"
    type="button"
    class="toolbar-button language-menu-button"
    mat-button
    [matMenuTriggerFor]="menu">
    <div data-testid="language-menu-flag" [translate]="selectedLanguageCode"></div>
  </button>
  <mat-menu #menu="matMenu">
    <button
      *ngFor="let item of languagesSet"
      [attr.data-testid]="'change-language-' + item"
      mat-menu-item
      type="button"
      (click)="languageCodeSelected(item)">
      <div class="menu-flag-item">
        {{ item | translate }}
      </div>
    </button>
  </mat-menu>
</div>

<mat-dialog-content class="whatsapp-templates">
  <ng-container *ngFor="let template of templatesFromLanguage; index as i">
    <app-whatsapp-template-item
      [attr.data-testid]="'item-' + i"
      *ngIf="template.language === selectedLanguageCode"
      (click)="dialogRef.close(template)"
      [template]="template">
    </app-whatsapp-template-item>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button data-testid="cancel" mat-raised-button mat-dialog-close aria-label="back">{{ closeLabel }}</button>
</mat-dialog-actions>
